import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import React, { useEffect, useRef } from "react";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

const TablaEmpleados = ({ datos }) => {
  const { token } = useContextUsuario();
  const { setListaEmpleados , ActualizarLista } = useContextEmpleado();
  const tableRef = useRef();
  const renderTelefonos = (telefonos) => {
    if (!Array.isArray(telefonos) || telefonos.length === 0) return "—";
    return telefonos.map(t => t.telefono).join("<br>");
  };

  useEffect(() => {
    $(tableRef.current).DataTable({
      data: datos,
      columns: [
        { targets: 0, title: "Id", data: "id" },
        { targets: 1, title: "Nombre Competo", data: "nombreCompleto" },
        { targets: 2, title: "Identidad", data: "identidad" },
        { targets: 4, title: "Correo", data: "correo" },
        { targets: 5, title: "Teléfonos", data: "EmpleadoTelefonos", render: renderTelefonos },
      ],
      paging: true,
      lengthChange: true,
      pageLength: 10,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: true,
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      dom:
        "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      responsive: true,
      language: {
        decimal: "",
        emptyTable: "No hay información",
        info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
        infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
        infoFiltered: "(Filtrado de _MAX_ total entradas)",
        infoPostFix: "",
        thousands: ",",
        lengthMenu: "Mostrar _MENU_ Entradas",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        zeroRecords: "Sin resultados encontrados",
        search: "Buscar",
        paginate: {
          first: "|<<",
          last: ">>|",
          next: ">>",
          previous: "<<",
        },
      },
      destroy: true,
    });
    //}
  }, [datos]);

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        id="clientes"
        className="table table-bordered table-hover"
      ></table>
    </div>
  );
};

export default TablaEmpleados;